import { render } from "./MapInfoWindow.vue?vue&type=template&id=3c318000"
import script from "./MapInfoWindow.vue?vue&type=script&lang=js"
export * from "./MapInfoWindow.vue?vue&type=script&lang=js"
script.render = render

export default script